
interface SearchBarProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  viewMode: 'grid' | 'list';
  setViewMode: (mode: 'grid' | 'list') => void;
}

export function SearchBar({ searchQuery, setSearchQuery, viewMode, setViewMode }: SearchBarProps) {
  return (
    <div className="flex flex-col sm:flex-row gap-4 items-center">
      {/* Search Input */}
      <div className="flex-1 w-full relative">
        <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-amber-400 text-lg"></i>
        <input
          type="text"
          placeholder="제품명, 제조업체, 지역으로 검색..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-full pl-12 pr-4 py-3 border border-amber-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-400 focus:border-transparent text-sm bg-white"
        />
      </div>

      {/* View Mode Toggle */}
      <div className="flex gap-2 bg-amber-50 p-1 rounded-lg border border-amber-100">
        <button
          onClick={() => setViewMode('grid')}
          className={`px-4 py-2 rounded-md transition-all whitespace-nowrap ${
            viewMode === 'grid'
              ? 'bg-white text-amber-700 shadow-sm'
              : 'text-amber-600/60 hover:text-amber-700'
          }`}
        >
          <i className="ri-grid-line text-lg"></i>
        </button>
        <button
          onClick={() => setViewMode('list')}
          className={`px-4 py-2 rounded-md transition-all whitespace-nowrap ${
            viewMode === 'list'
              ? 'bg-white text-amber-700 shadow-sm'
              : 'text-amber-600/60 hover:text-amber-700'
          }`}
        >
          <i className="ri-list-check text-lg"></i>
        </button>
      </div>
    </div>
  );
}
